import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ActionItem, ActionPlanService } from '../../../providers/storage-api/actionplan.service';

@Injectable()
export class ActionItemCacheService {
  private readonly _map: Map<string, ActionItem[]>;

  private readonly _list = new Subject<[actionPlanId: string, items: ActionItem[]]>();

  readonly list$ = this._list.asObservable();

  constructor(private actionPlanService: ActionPlanService) {
    this._map = new Map<string, ActionItem[]>();
  }

  async list(actionPlanId: string): Promise<void> {
    if (!this._map.has(actionPlanId)) {
      const items = await this.actionPlanService.listActionItems(actionPlanId, {
        page_size: 1000, // to get all
      });

      this._map.set(actionPlanId, items.data);
    }

    this.emitList(actionPlanId);
  }

  set(actionPlanId: string, ...actionItems: ActionItem[]): void {
    const items = this._map.get(actionPlanId) ?? [];

    const actionItemIds = actionItems.map((i) => i.item_id);

    const newItems = items.filter((i) => !actionItemIds.includes(i.item_id));
    newItems.push(...actionItems);

    this._map.set(actionPlanId, newItems);

    this.emitList(actionPlanId);
  }

  delete(actionPlanId: string, ...actionItemIds: string[]): void {
    const items = this._map.get(actionPlanId);

    this._map.set(
      actionPlanId,
      items.filter((i) => !actionItemIds.includes(i.item_id as string))
    );

    this.emitList(actionPlanId);
  }

  private emitList(actionPlanId: string): void {
    this._list.next([actionPlanId, this._map.get(actionPlanId)]);
  }
}
